import Image from "next/image"
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css';
import { useState } from "react";


interface MyHeartsMateProps {
  setAttrId: (attrId: number) => void;
  setCustomName: (name: string) => void;
  processScroll: () => void;
}

const product_ips = [
  {
    "name": "Rose",
    "image": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/Rose-1.png",
    "image_hover": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/Rose.png",
    "attr_id": 586,
  },
  {
    "name": "Theo",
    "image": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/Theo-1.png",
    "image_hover": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/Theo.png",
    "attr_id": 590,
  },
  {
    "name": "Elio",
    "image": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/Elio-1.png",
    "image_hover": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/Elio.png",
    "attr_id": 587,
  },
  {
    "name": "Hiro",
    "image": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/Hiro-1.png",
    "image_hover": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/Hiro.png",
    "attr_id": 588,
  },
  {
    "name": "Alexi",
    "image": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/Alexi-1.png",
    "image_hover": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/Alexi.png",
    "attr_id": 591,
  },
  {
    "name": "Snowie",
    "image": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/Snowie-1.png",
    "image_hover": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/Snowie.png",
    "attr_id": 589,
  }
]

const MyHeartsMate = (props: MyHeartsMateProps) => {
  const { setAttrId, setCustomName } = props;
  const ip_name = ["Rose", "Theo", "Elio", "Hiro", "Alexi", "Snowie"]
  let ip_status = [false, false, false, false, false, false]

  const [ipHover, setIpHover] = useState(ip_status)

  const handleEnterHover = (hover_name: string) => {
    ip_status[ip_name.indexOf(hover_name)] = true

    setIpHover(ip_status)
  }

  const handleLeaveHover = (hover_name: string) => {
    ip_status[ip_name.indexOf(hover_name)] = false

    setIpHover(ip_status)
  }

  const handleClick = (attr_id: number, name: string) => {
    setAttrId(attr_id);
    setCustomName(name);

    props.processScroll();
  }

  return (
    <div className="px-0 my-12 md:container md:my-20">
      <div className="flex justify-center items-center text-[24px] md:text-[32px] leading-none md:-tracking-[1.6px] text-[#C6C6C6] font-dmsans font-medium">
        Shop by
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/my-hearts-mate.png"}
          alt="shop by my hearts mate image"
          width={1839}
          height={310}
          quality={100}
          className="max-w-[204px] md:max-w-[248px] ml-2 md:ml-4"
        />
      </div>
      <div className="mt-12">
        <div className="justify-between hidden md:flex">
          {product_ips.map((ip, index) => (
            <div
              key={index}
              className="max-w-[153px] cursor-pointer"
              onMouseEnter={() => handleEnterHover(ip.name)}
              onMouseLeave={() => handleLeaveHover(ip.name)}
              onClick={() => handleClick(ip.attr_id, ip.name)}
            >
              {ipHover[ip_name.indexOf(ip.name)] ? (
                <Image
                  src={ip.image_hover}
                  alt={ip.name + " image"}
                  width={460}
                  height={464}
                  quality={100}
                />
              ) : (
                <Image
                  src={ip.image}
                  alt={ip.name + " image"}
                  width={460}
                  height={464}
                  quality={100}
                />
              )}
            </div>
          ))}
        </div>
        <div className="px-0 md:hidden">
          <Swiper
            spaceBetween={0}
            slidesPerView={2.5}
            className="mySwiper"
          >
            {product_ips.map((ip, index) => (
              <SwiperSlide key={index} className={`${index === 0 ? "ml-[35px]" : ""}`}>
                <div
                  className="max-w-[130px]"
                  onMouseEnter={() => handleEnterHover(ip.name)}
                  onMouseLeave={() => handleLeaveHover(ip.name)}
                  onClick={() => handleClick(ip.attr_id, ip.name)}
                >
                  {ipHover[ip_name.indexOf(ip.name)] ? (
                    <Image
                      src={ip.image_hover}
                      alt={ip.name + " image"}
                      width={460}
                      height={464}
                      quality={100}
                    />
                  ) : (
                    <Image
                      src={ip.image}
                      alt={ip.name + " image"}
                      width={460}
                      height={464}
                      quality={100}
                    />
                  )}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  )
}

export default MyHeartsMate
